import React from 'react';

function Loading() {
    return null;
}

export default Loading;